// Section label for a group of content within a page (e.g. "Recent lessons",
// "Quick actions"). Replaces the uppercase, letter-spaced Inter eyebrow label that
// was repeated identically above every section on the dashboard — four sections,
// four visually indistinguishable headers. Serif + sentence case reads as an actual
// heading instead of decoration, so sections stop looking interchangeable.

import type { ReactNode } from 'react'

export function SectionHeader({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, gap: 12 }}>
      <div style={{ font: 'var(--text-section)', color: 'var(--ink)' }}>{children}</div>
      {action}
    </div>
  )
}
